export function tripName(trip: {
  cityA: { name: string };
  cityB: { name: string };
}) {
  return `${trip.cityA.name} ↔ ${trip.cityB.name}`;
}
